// Report-scoped ownership. Neither duplicate callbacks nor an older GET may
// append sections or replace a more recent Next Steps snapshot.
export const createNextStepsState = () => {
  let epoch = 0, read = 0, acceptedRead = 0, active = null, current;
  return {
    claim() {
      if (active) return null;
      epoch += 1;
      active = { epoch, controller: new AbortController(), jobId: null };
      return active;
    },
    owns(attempt) { return active === attempt && !attempt.controller.signal.aborted; },
    release(attempt) { if (active !== attempt) return false; active = null; return true; },
    cancel() { epoch += 1; active?.controller.abort(); active = null; },
    beginRead() { return { epoch, sequence: ++read }; },
    accept(report, ticket, sourceInvalidated = false) {
      if (ticket.epoch !== epoch || ticket.sequence < acceptedRead) return current;
      // A saved replacement SQIS explicitly invalidates its dependent report.
      if (sourceInvalidated && report === null) {
        acceptedRead = ticket.sequence;
        current = null;
        return current;
      }
      const previousTime = Date.parse(current?.generated_at || '');
      const incomingTime = Date.parse(report?.generated_at || '');
      if (current && (!report || (Number.isFinite(previousTime) && (!Number.isFinite(incomingTime) || incomingTime < previousTime)))) return current;
      acceptedRead = ticket.sequence;
      current = report;
      return current;
    },
  };
};
